import { useState } from "react";
import useDelete from "../../../hooks/useDelete";
import usePostPut from "../../../hooks/usePostPut";

export function useServiceSchedule(refetchSschedules: () => Promise<void>) {

    const [date, setDate] = useState<string>('')

    const { handleUpdateOrCreate, isHandlingUpdateOrCreate } = usePostPut<{ fk_id_automated_service: number, send_date: string }>({
        onSuccess: () => refetchSschedules(),
        onSettled: () => setDate('')
    })

    const { handleDelete } = useDelete({
        onSettled: () => refetchSschedules()
    })

    return {
        date,
        setDate,
        isHandlingUpdateOrCreate,
        handleUpdateOrCreate,
        handleDelete
    }
}